import createPortal from 'helpers/createPortal';

export default createPortal('OnboardingAppBarPortal') as any;
